import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { COADisplayAccount } from '../../../types';
import { CoaGroupWizardContainer } from './group-wizard-container';

interface EditCoaGroupSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  row: COADisplayAccount;
}

export const EditCoaGroupSidebar = ({ isOpen, onClose, row }: EditCoaGroupSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        <FormattedMessage id="common.edit_group" defaultMessage="Edit group" />
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <CoaGroupWizardContainer onClose={onClose} row={row} />
  </Sidebar>
);
